export default "__VITE_ASSET__CozTeHTD__"